import React from 'react'
import { useState,useEffect } from 'react'
import axios from './axios'
import './index.css'
import YouTube from 'react-youtube'
import movieTrailer from 'movie-trailer'
const Row = ({title,fetchUrl}) => {
    const baseUrl = "https://image.tmdb.org/t/p/original";
 
    const [movies,setMovies]=useState([]);
     
    const [turl,setTurl]=useState("");

     const opts = {
        height: "390",
        width: "100%",
        playerVars: {
            autoplay: 1,
        }
    }

    // console.log({param})
    useEffect(() => {
        async function fetchData(){
          const request= await axios.get(fetchUrl);
         setMovies(request.data.results)
         return request;
        }
        fetchData()
        console.log(movies)
    }, [fetchUrl])
    const clickHandler=(movie)=>{
         
        if(turl){
            setTurl("");
        } else {
            movieTrailer(movie.id,{ tmdbId: movie.id, } )
            .then((url) => {
                const urlParams = new URLSearchParams(new URL(url).search);
                setTurl(urlParams.get('v'));
            })
            .catch(() => console.log('Temporary Unavailable'))
        
    }
    }
   
    return (
        <>
        
        <div className="row">
            <h2  className="row_name"style={{color:"#d6ed17ff"}}>{title} </h2>
            <div className="container">
                {movies.map(i=>(
                  <img onClick={()=>{clickHandler(i)}} key={i.id}className='poster'src={`${baseUrl}${i.poster_path}`} alt={i.name} />
                ))}
            </div>
              {turl && <YouTube videoId = {turl} opts = {opts}/> }
        </div>
        </>
    )
}

export default Row